export default __webpack_public_path__ + "static/media/banner-mobile-1x.756de2ca.jpg";